// eslint-disable-next-line consistent-return
var calculateStyles = (side, width, height, visible) => {
  switch (side === null || side === void 0 ? void 0 : side.toLowerCase()) {
    case 'right':
      {
        return {
          right: visible ? 0 : "-".concat(width),
          width: "".concat(width)
        };
      }
    case 'left':
      {
        return {
          left: visible ? 0 : "-".concat(width),
          width: "".concat(width)
        };
      }
    case 'top':
      {
        return {
          top: visible ? 0 : "-".concat(height),
          height: "".concat(height)
        };
      }
    case 'bottom':
      {
        return {
          bottom: visible ? 0 : "-".concat(height),
          height: "".concat(height)
        };
      }
  }
};

export { calculateStyles };
//# sourceMappingURL=util.js.map
